import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import SEOHelmet from '../components/SEOHelmet';

const ResetPassword = () => {

  const location = useLocation();
  const { email, otp } = location.state || {};

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleReset = async () => {


    if (!email || !otp || !password) {
      alert("Missing required data");
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/reset-password`,
        {
          email,
          otp,
          password
        }
      );

      alert("Password updated successfully");


    } catch (err) {

      alert("Failed to reset password");
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#0b3d91",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <SEOHelmet page="forgotPassword" canonicalUrl="https://www.assetflows.in/reset-password" noIndex />
      <div
        style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "10px",
          width: "350px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            backgroundColor: "#0b3d91",
            color: "white",
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          Reset Password
        </h2>

        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: "100%", padding: "10px", marginTop: "20px" }}
        />

        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          style={{ width: "100%", padding: "10px", marginTop: "15px" }}
        />

        <button
          onClick={handleReset}
          style={{
            width: "100%",
            padding: "10px",
            marginTop: "20px",
            backgroundColor: "#0b3d91",
            color: "white",
            border: "none",
          }}
        >
          Update Password
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;